<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<ymqcList></ymqcList>
		</div>
		<div class="add" v-if="type==='add'">
			<ymqcAdd></ymqcAdd>
			<div class="settlementBox">
				<ymqcSettlement></ymqcSettlement>
			</div>
		</div>
	</div>
</template>
<script>
	import ymqcList from "./comp/ymqc_list.vue"
	import ymqcAdd from "./comp/ymqc_add.vue"
	import ymqcSettlement from "./comp/ymqc_settlement.vue"
	export default {
		components:{ymqcList,ymqcAdd,ymqcSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.ymqc.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
